<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Leveringen</h1>
      </div>

      <div class="dropdown">
        <button class="btn btn-dark" type="button" id="dropdownMenuButton" v-on:click="modalToevoegenLevering()">
          <i class="fas fa-plus"></i> Levering toevoegen
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="leveringen && leveringen.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="leveringColumns"
      :rows="leveringen"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="leveringModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="levering && levering.klant_info"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ editModalTitle }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="leveringTab" v-if="levering">
                <label>Datum</label>
                <date-picker
                  v-model="levering.datum"
                  placeholder="Kies datum"
                  :value-type="'YYYY-MM-DD'"
                  :editable="false"
                  :format="'YYYY-MM-DD'"
                  @change="checkBeschikbaarheid"
                ></date-picker>
                <label>Richtuur</label>
                <vue-timepicker v-model="levering.richtuur" :minute-interval="15"></vue-timepicker>
                <p class="d-flex justify-content-end" v-html="beschikbaarheidFeedback">
                  {{ beschikbaarheidFeedback }}
                </p>
                <!--
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="levering.vrachtwagen"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een vrachtwagen -</option>
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="levering.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }} ({{
                      vrachtwagen.nummerplaat
                    }})
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="levering.chauffeur"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een chauffeur -</option>
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="levering.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                -->
                <hr />
                <label>Klant</label>
                <model-list-select
                  :list="klanten"
                  option-value="id"
                  option-text="klantnaam"
                  v-model="levering.klant"
                  placeholder="- Kies klant -"
                  @input="changeCustomer"
                ></model-list-select>
                <div v-if="levering.klant">
                  <label>Werf</label>
                  <div class="idem-container">
                    <select
                      v-if="levering.gegevens_idem_klant !== '1'"
                      class="form-control"
                      v-model="levering.werf"
                      @change="changeWerf()"
                    >
                      <option value>- Kies een werf -</option>
                      <option value="new">Nieuwe werf aanmaken</option>
                      <template v-for="werf in werven">
                        <option :key="werf.id" :value="werf.id" :selected="levering.werf">
                          {{ werf.beschrijving }}
                        </option>
                        <option :key="werf.id" disabled
                          >&#8627; {{ werf.straat }} {{ werf.huisnummer }} - {{ werf.gemeente }}</option
                        >
                      </template>
                    </select>
                    <input
                      id="idem"
                      class="idem"
                      type="checkbox"
                      v-model="levering.gegevens_idem_klant"
                      true-value="1"
                      false-value="0"
                    />
                    <label class="idem" for="idem">Alle gegevens overnemen van klant?</label>
                  </div>
                </div>

                <label>Product</label>
                <select class="form-control" v-model="levering.leveringsproduct">
                  <option value>- Kies een leveringsproduct -</option>
                  <option
                    v-for="leveringsproduct in leveringsproducten"
                    :key="leveringsproduct.id"
                    :value="leveringsproduct.id"
                    :selected="levering.leveringsproduct"
                  >
                    {{ leveringsproduct.beschrijving }}
                  </option>
                </select>
                <label>Aantal</label>
                <div class="sizeContainer">
                  <input class="form-control" type="text" v-model="levering.gewicht" />
                  <select class="form-control w-16" v-model="levering.gewichtType">
                    <option value="ton">ton</option>
                    <option value="m3">m3</option>
                  </select>
                </div>
                <hr />
                <label>Vrachtwagen</label>
                <select class="form-control" v-model="levering.vrachtwagen">
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="levering.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }}
                  </option>
                </select>
                <label>Chauffeur</label>
                <select class="form-control" v-model="levering.chauffeur">
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="levering.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Betalingswijze</label>
                <select class="form-control" v-model="levering.betalingswijze" :selected="levering.betalingswijze">
                  <option value disabled>- Kies betalingswijze -</option>
                  <option value="Factuur">Factuur</option>
                  <option value="Overschrijving voor levering">
                    Overschrijving voor levering
                  </option>
                  <option value="Contant">Contant</option>
                  <option value="Bancontact">Bancontact</option>
                </select>
                <!--
                <div v-if="levering.betalingswijze == 'Overschrijving'">
                  <label>Leverbon nr.</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="levering.leverbon"
                  />
                </div>
                -->
                <div v-if="levering.klant_info.type == 'Particulier'">
                  <label>Factuur (?)</label>
                  <select class="form-control" v-model="levering.factuur" :selected="levering.factuur">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
                </div>
                <label>Betalingstermijn</label>
                <input class="form-control" type="text" v-model="levering.klant_info.betalingstermijn" disabled />
                <div v-if="levering.prijsberekening == 'Speciaal'">
                  <label>Prijs (€)</label>
                  <input v-model="levering.prijs_speciaal" type="text" class="form-control" />
                </div>
                <div>
                  <label>Transport zone</label>
                  <select
                    class="form-control"
                    v-model="levering.transportzone"
                    v-if="levering.prijsberekening == 'Forfaitair'"
                  >
                    <option value>- Kies een transportzone -</option>
                    <option
                      v-for="transportzone in transportzones_ff"
                      :key="transportzone.id"
                      :value="transportzone.id"
                      :selected="levering.transportzone"
                    >
                      {{ transportzone.beschrijving }} - {{ transportzone.type }} (€{{ transportzone.prijs }})
                    </option>
                  </select>
                  <select class="form-control" v-model="levering.transportzone" v-else>
                    <option value>- Kies een transportzone -</option>
                    <option
                      v-for="transportzone in transportzones_pt"
                      :key="transportzone.id"
                      :value="transportzone.id"
                      :selected="levering.transportzone"
                    >
                      {{ transportzone.beschrijving }} - {{ transportzone.type }} (€{{ transportzone.prijs }})
                    </option>
                  </select>
                </div>
                <label>Notities</label>
                <textarea class="form-control" v-model="levering.notities_levering" placeholder="Notities"></textarea>
                <hr />
                <div v-if="checkNewLevering === true">
                  <label>Verstuur mail?</label>
                  <select class="form-control" v-model="levering.mail">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
                </div>
                <button
                  v-if="checkNewLevering === false"
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(levering.id, 'plaatsing')"
                >
                  Print vrachtbon
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewLevering === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteLevering()"
            >
              Verwijderen
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Sluiten
            </button>
            <button v-if="checkNewLevering" type="button" class="btn btn-primary" v-on:click="createLevering()">
              Opslaan
            </button>
            <button v-else type="button" class="btn btn-primary" v-on:click="updateLevering()">
              Aanpassen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="nieuweWerfModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Nieuwe werf aanmaken
            </h5>
          </div>
          <div class="modal-body">
            <div v-if="werf">
              <label>Beschrijving</label
              ><input type="text" class="form-control" v-model="werf.beschrijving" placeholder="Beschrijving" />
              <label>Straat</label
              ><input type="text" class="form-control" v-model="werf.straat" placeholder="Straat" />
              <label>Huisnummer</label
              ><input type="text" class="form-control" v-model="werf.huisnummer" placeholder="Huisnummer" />
              <label>Postcode</label
              ><input type="text" class="form-control" v-model="werf.postcode" placeholder="Postcode" />
              <label>Gemeente</label
              ><input type="text" class="form-control" v-model="werf.gemeente" placeholder="Gemeente" />
              <label>Land</label><input type="text" class="form-control" v-model="werf.land" placeholder="Land" />
              <hr />
              <label>Contactpersoon</label>
              <input type="text" class="form-control" v-model="werf.contactpersoon" placeholder="Contactpersoon" />
              <label>Telefoon</label>
              <input type="text" class="form-control" v-model="werf.telefoon" placeholder="Telefoon" />
              <label>E-mail</label>
              <input type="text" class="form-control" v-model="werf.email" placeholder="E-mail" />
              <hr />
              <label>Plaatsing</label>
              <select class="form-control" v-model="werf.plaatsing">
                <option value="">- Kies plaatsingstype -</option>
                <option value="Openbaar">Openbaar</option>
                <option value="Privé">Privé</option>
              </select>
              <label>Opmerking</label>
              <textarea class="form-control" v-model="werf.opmerking" placeholder="Opmerking"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="returnModal()">
              Terug
            </button>
            <button type="button" class="btn btn-primary" v-on:click="createWerf()">
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/nl-be";
import moment from "moment";
import "moment/locale/nl-be";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

//import VueUploadMultipleImage from "vue-upload-multiple-image";
//import { filter } from "vue/types/umd";

moment.updateLocale("nl-be", {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

export default {
  name: "app",
  components: {
    DatePicker,
    VueTimepicker,
    ModelListSelect,
    //VueUploadMultipleImage,
  },
  data() {
    return {
      beschikbaarheidscheck: true,
      checkNewLevering: false,
      importType: "-1",
      importCategory: "-1",
      beschikbaarheidFeedback: "",
      types: [
        {
          name: "Leveringen",
        },
        {
          name: "Leveringen",
        },
        {
          name: "Leveradressen",
        },
      ],
      idemAdres: false,
      editModalTitle: "",
      levering: {
        mail: 1,
      },
      klantnaam: "",
      contacten: {},
      vrachtwagens: {},
      chauffeurs: {},
      transportzones: {},
      stortplaatsen: {},
      leveringsproducten: {},
      klanten: [],
      werven: {},
      werf: {
        klant: "",
      },
      leveringen: {
        attributes: [],
        related: [],
      },
      leveringColumns: [
        {
          label: "#",
          field: "id",
          type: "number",
          filterOptions: { enabled: false },
        },
        {
          label: "Klant",
          field: (row) => this.fnKlant(row),
          filterOptions: { enabled: true, filterFn: this.fnFilterKlant },
        },
        {
          label: "Adres",
          field: (row) => this.fnAdres(row),
          filterOptions: { enabled: true, filterFn: this.fnFilterKlant },
        },
        {
          label: "Datum",
          field: "datum",
          filterOptions: { enabled: true },
        },
        {
          label: "Afvalproduct",
          field: "afval_info.naam",
          filterOptions: { enabled: true },
        },
        {
          html: true,
          label: "Betaald",
          field: (row) => this.fnBetalingsstatus(row),
          filterOptions: { enabled: true },
        },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getLeveringen();
    this.getVrachtwagens();
    this.getChauffeurs();
    this.getTransportzones();
    this.getContainers();
    this.getStortplaatsen();
    this.getAfvalproducten();
  },
  computed: {
    transportzones_ff: function() {
      return this.transportzones.filter(function(zone) {
        return zone.type == "Forfaitair";
      });
    },
    transportzones_pt: function() {
      return this.transportzones.filter(function(zone) {
        return zone.type !== "Forfaitair";
      });
    },
  },
  methods: {
    checkinput() {
      console.log(this.levering);
    },
    changeWerf() {
      if (this.levering.werf == "new") {
        $("#leveringModal").modal("hide");
        $("#nieuweWerfModal").modal("show");
        this.levering.werf = "";
      }
    },
    changeCustomer(item) {
      this.getWerven(item);
    },
    uploadImageSuccess() {
      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          levering: this.levering,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    beforeRemove(index, done) {
      done();

      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          levering: this.levering,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    idemAdresChanged() {
      if (this.idemAdres) {
        for (let i = 0; i < this.klanten.length; i++) {
          if (this.klanten[i].id == this.levering.klant) {
            this.werf.straat = this.klanten[i].straat;
            this.werf.huisnummer = this.klanten[i].huisnummer;
            this.werf.gemeente = this.klanten[i].gemeente;
            this.werf.postcode = this.klanten[i].postcode;
            this.werf.land = this.klanten[i].land;
          }
        }
      } else {
        this.werf.straat = "";
        this.werf.huisnummer = "";
        this.werf.gemeente = "";
        this.werf.postcode = "";
        this.werf.land = "";
      }
    },
    fnBetalingsstatus(rowObj) {
      if (rowObj.betalingsstatus == "Betaald") {
        return "<span class='p'></span> Betaald";
      } else {
        return "<span class='np'></span> Niet betaald";
      }
    },
    fnOphaling(rowObj) {
      if (rowObj.ophalingsdatum == "0000-00-00") {
        return "-";
      } else {
        return rowObj.ophalingsdatum;
      }
    },
    fnAdres(rowObj) {
      if (rowObj.gegevens_idem_klant == "1") {
        if (rowObj.klant_info !== null) {
          return (
            rowObj.klant_info.straat +
            " " +
            rowObj.klant_info.huisnummer +
            ", " +
            rowObj.klant_info.postcode +
            " " +
            rowObj.klant_info.gemeente
          );
        } else {
          return "";
        }
      } else {
        if (rowObj.werf_info !== null) {
          return (
            rowObj.werf_info.straat +
            " " +
            rowObj.werf_info.huisnummer +
            ", " +
            rowObj.werf_info.postcode +
            " " +
            rowObj.werf_info.gemeente
          );
        } else {
          return "";
        }
      }
    },
    fnKlant(rowObj) {
      if (rowObj.klant_info) {
        if (rowObj.klant_info.type == "Particulier") {
          return rowObj.klant_info.naam + " " + rowObj.klant_info.voornaam;
        } else {
          return rowObj.klant_info.bedrijfsnaam;
        }
      }
    },
    fnFilterKlant(data, filterString) {
      console.log(data + ", " + filterString);

      if (typeof data !== "undefined") {
        return data.toLowerCase().includes(filterString.toLowerCase());
      } else {
        return false;
      }
    },
    printVrachtbon(id) {
      window.open("https://hofman.weblion.be/api/levering.php?l=" + id, "_blank");
    },
    checkBeschikbaarheidFeedback() {
      this.beschikbaarheidFeedback = "";
      var teCheckenDatum = moment(this.levering.datum, "YYYY-MM-DD");
      var teCheckenContainer = this.levering.container;

      for (var i = 0; i < this.leveringen.length; i++) {
        if (teCheckenContainer == this.leveringen[i]["container"]) {
          if (teCheckenDatum.isAfter(moment(this.leveringen[i]["datum"], "YYYY-MM-DD"))) {
            if (this.leveringen[i]["ophalingsdatum"] == "0000-00-00") {
              this.beschikbaarheidFeedback =
                "<span class='badge badge-warning'>Let op: ophalingsdatum onbekend!</span>";
              break;
            }
          }
        }
      }
    },
    checkBeschikbaarheid() {
      var nietBeschikbareContainers = [];

      for (var i = 0; i < this.leveringen.length; i++) {
        var teCheckenDatum = moment(this.levering.datum, "YYYY-MM-DD");
        var ophalingsdatum = this.leveringen[i]["ophalingsdatum"];
        var datum = this.leveringen[i]["datum"];

        if (teCheckenDatum.isBetween(datum, ophalingsdatum)) {
          nietBeschikbareContainers.push(this.leveringen[i]["container"]);
        }
      }

      for (var ii = 0; ii < this.containers.length; ii++) {
        if (nietBeschikbareContainers.includes(this.containers[ii]["id"])) {
          this.containers[ii]["beschikbaar"] = false;
        } else {
          this.containers[ii]["beschikbaar"] = true;
        }
      }

      if (this.levering.ophalingsdatum !== undefined) {
        if (this.levering.ophalingsdatum !== null) {
          this.beschikbaarheidscheck = false;
        } else {
          this.beschikbaarheidscheck = true;
        }
      }

      this.beschikbaarheidscheck = false;

      console.log(this.beschikbaarheidscheck);
    },
    werfFn(rowObj) {
      var werven = this.werven;
      var werf_id = rowObj.werf;

      for (var i = 0; i < werven.length; i++) {
        if (werven[i]["id"] == werf_id) {
          return werven[i]["beschrijving"];
        }
      }
    },
    adresFn(rowObj) {
      return rowObj.straat + " " + rowObj.huisnummer;
    },
    getContainers() {
      axios.get("https://hofman.weblion.be/api/containers/").then((response) => {
        response.data.sort((a, b) => a.grootte - b.grootte);
        this.containers = response.data;
      });
    },
    getStortplaatsen() {
      axios.get("https://hofman.weblion.be/api/stortplaatsen/").then((response) => {
        this.stortplaatsen = response.data;
      });
    },
    getAfvalproducten() {
      axios.get("https://hofman.weblion.be/api/leveringsproducten/").then((response) => {
        this.leveringsproducten = response.data;
      });
    },
    getLeveringen() {
      axios.get("https://hofman.weblion.be/api/leveringen/").then((response) => {
        this.leveringen = response.data;
        console.log(this.leveringen);
      });
    },
    getVrachtwagens() {
      axios.get("https://hofman.weblion.be/api/vrachtwagens/").then((response) => {
        this.vrachtwagens = response.data;
      });
    },
    getChauffeurs() {
      axios.get("https://hofman.weblion.be/api/chauffeurs/").then((response) => {
        this.chauffeurs = response.data;
      });
    },
    getTransportzones() {
      axios.get("https://hofman.weblion.be/api/transportzones/").then((response) => {
        this.transportzones = response.data;
      });
    },
    getWerven(klant) {
      axios
        .get("https://hofman.weblion.be/api/werven/", {
          params: {
            klant: klant,
          },
        })
        .then((response) => {
          console.log("werven", response.data);
          this.werven = response.data;
        });
    },
    deleteLevering() {
      axios
        .delete("https://hofman.weblion.be/api/leveringen/", {
          data: {
            levering_id: this.levering.id,
          },
        })
        .then((response) => {
          this.getLeveringen();
          $("#leveringModal").modal("hide");
          console.log(response.data);
        });
    },
    updateLevering() {
      axios
        .put("https://hofman.weblion.be/api/leveringen/", {
          levering: this.levering,
        })
        .then((response) => {
          this.getLeveringen();
          $("#leveringModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createLevering() {
      axios
        .post("https://hofman.weblion.be/api/leveringen/", {
          levering: this.levering,
        })
        .then((response) => {
          this.getLeveringen();
          $("#leveringModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalNieuweWerf() {
      this.werf.klant = this.levering.klant;
      for (let i = 0; i < this.klanten.length; i++) {
        if (this.klanten[i].id == this.levering.klant) {
          this.klantnaam = this.klanten[i].bedrijfsnaam;
        }
      }
      $("#leveringModal").modal("hide");
      $("#nieuweWerfModal").modal("show");
    },
    returnModal() {
      $("#leveringModal").modal("show");
      $("#nieuweWerfModal").modal("hide");
    },
    modalToevoegenLevering() {
      this.levering = {
        mail: 1,
        klant_info: {
          betalingstermijn: "",
        },
        richtuur: "",
      };
      this.editModalTitle = "Levering toevoegen";

      this.beschikbaarheidscheck = true;
      this.checkNewLevering = true;

      axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
        this.klanten = [res.data][0];
        $("#leveringModal").modal("show");
      });
    },
    onRowClick(table) {
      this.editModalTitle = "Levering aanpassen";
      this.levering = table.row;

      if (this.levering.fotos == "") {
        this.levering.fotos = [];
      }

      this.beschikbaarheidscheck = false;
      this.checkNewLevering = false;

      if (this.levering.klant) {
        this.getWerven(this.levering.klant);
      }

      axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
        console.log(res.data);
        this.klanten = res.data;
        $("#leveringModal").modal("show");
      });
    },
    selectionChanged(table) {
      this.leveringenSelected = table.selectedRows;
    },
    modalAanpassenLevering() {
      this.checkNewLevering = false;
      this.editModalTitle = "Levering aanpassen";

      $("#leveringModal").modal("show");
    },
    sLevering() {
      axios
        .post("https://hofman.weblion.be/api/leveringen/update.php", {
          levering: this.levering,
        })
        .then((res) => {
          console.log(res);
          this.getLeveringen();
        })
        .then(function() {
          $("#leveringModal").modal("hide");
        });
    },
    createWerf() {
      this.werf.klant = this.levering.klant;

      axios
        .post("https://hofman.weblion.be/api/werven/", {
          werf: this.werf,
        })
        .then((response) => {
          this.getWerven(this.levering.klant);
          $("#leveringModal").modal("show");
          $("#nieuweWerfModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 0px;
}

.vue__time-picker input.display-time {
  display: inline-block;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 3px;
  text-indent: 4px;
  color: #555;
}

.vue__time-picker {
  display: inline-block;
  width: 68%;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#leveringModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}

.modal input,
.modal .ui.search.dropdown,
.modal .mx-datepicker {
  display: inline-block;
  width: 68%;
  margin-bottom: 5px;
  font-size: 1rem;
}
.modal .ui.dropdown:not(.button) > .default.text {
  color: #6d767d;
}
.modal .mx-datepicker input {
  width: 100%;
  height: 38px;
  text-indent: 2px;
  font-size: 1rem;
}
.mx-datepicker-popup {
  z-index: 9999;
}
.mx-icon-calendar {
  margin-top: 0px;
}
.mx-input {
  box-shadow: none;
  border: 1px solid #ced4da;
}
.modal .ui.search.dropdown {
  border: 1px solid #ced4da;
}
.modal .ui.dropdown > .text {
  color: #495057;
}
.modal .mx-datepicker input {
  margin-bottom: 0px;
}
.btn-danger {
  margin-right: 210px;
}
.lnk {
  display: inline-block;
  width: 68%;
  font-size: 14px;
  padding-bottom: 10px;
  margin-top: -3px;
  text-decoration: underline;
  color: #007bff;
}
.checkContainer {
  width: 68%;
  display: inline-block;
}
.checkContainer input {
  display: inline-block;
  width: 16px;
  margin-bottom: 15px;
}
.checkContainer span {
  font-size: 15px;
}
.tab-content {
  padding-top: 25px;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.image-edit {
  display: none !important;
}

.image-container {
  width: 390px !important;
  height: 230px !important;
}

.image-list-item {
  width: 50px !important;
  height: 50px !important;
}

.image-list-container {
  max-width: 300px !important;
}

.image-list-container .image-list-item .show-img {
  max-width: 35px !important;
  max-height: 27px !important;
}

.modal .idem {
  display: inline-block;
  width: auto;
}

.modal input.idem {
  margin-right: 5px;
  width: 15px;
  height: 15px;
}

.modal label.idem {
  font-size: 14px;
}

.idem-container {
  display: inline-block;
  width: 68%;
}

.modal-body .idem-container .form-control {
  width: 100%;
}

.modal {
  overflow-y: auto;
}

.p,
.np {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #8cc040;
  margin-right: 3px;
}

.np {
  background-color: #d2212d;
}
.sizeContainer {
  width: 68%;
  display: inline-flex;
  flex-direction: row;
}

.sizeContainer select {
  width: 80px !important;
}

.sizeContainer input {
  display: flex !important;
  flex-grow: 1 !important;
}
</style>
